import { useEffect } from "react";
import { useAtomValue } from "jotai";
import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import { useOrganizationApi } from "@/hooks/apiHooks/useOrganizationApi";
import { locationStatusCountsAtom } from "@/store/organizationAtoms";

// Notification badge for the admin top-bar Clients link: shows the count of
// LOCATIONS awaiting approval (approval is per-location, DecisionLog §1.2;
// #332) — the same signal as the Clients list's "Awaiting Approval" column.
// Pending only: a location waiting for payment (#434) has passed review and
// waits on the customer's card, so it is not counted — as the API's own
// pending counts do not count it.
export const PendingClientsBadge = () => {
    const { getOrganizationStatuses } = useOrganizationApi();
    const counts = useAtomValue(locationStatusCountsAtom);

    useEffect(() => {
        getOrganizationStatuses().catch(() => {
            /* count is non-critical chrome; ignore failures */
        });
    }, [getOrganizationStatuses]);

    if (!counts.pending) {
        return null;
    }

    return (
        <Badge
            color={ComponentColor.Warning}
            size={ComponentSize.SM}
            className="ml-1"
            title={`${counts.pending} ${counts.pending === 1 ? "location" : "locations"} awaiting approval`}
        >
            {counts.pending}
        </Badge>
    );
};
